export const LOADING_COMPETENCIES_TYPE = "LOADING_COMPETENCIES_TYPE";
export const SAVE_LOADING_COMPETENCIES_TYPE = "SAVE_LOADING_COMPETENCIES_TYPE";
export const GET_COMPETENCIES_TYPE = "GET_COMPETENCIES_TYPE";
export const FORM_FAIL = "FORM_FAIL";
export const COMPETENCIES_TYPE_FAIL = "COMPETENCIES_TYPE_FAIL";
export const LOADING_COMPETENCIES_TYPE_BY_ID = "LOADING_COMPETENCIES_TYPE_BY_ID";
export const GET_COMPETENCIES_TYPE_BY_ID = "GET_COMPETENCIES_TYPE_BY_ID";

